import { render, staticRenderFns } from "./profile-patients.vue?vue&type=template&id=ebe8903e&"
import script from "./profile-patients.vue?vue&type=script&lang=js&"
export * from "./profile-patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports